<!-- container-xxl -->
<div class="content-wrapper p-0 filter-outer-container innovation-showcase-outer-container">
  <app-content-header [contentHeader]="contentHeader"></app-content-header>
  <div class="content-body content-body-outer-img-container">
    <img src="assets\images\innovation-showcase\Group 201.png" alt="Group 201.png">
  </div>
  <div class="first-per-container">
    <div class="first-per-box-container">
      <p> <span > The MNRE R&D Innovation Showcase on Energy (RISE),</span> has been designed by the MNRE R&D Division to
        provide an
        online platform that recognises and features innovative and promising renewable energy technology solutions
        indigenously developed by entrepreneurs, start-ups, industry, MSMEs, labs, researchers, academicians –
        ‘innovations from India, for India’. The platform takes an inclusive approach by looking to encourage credible
        informal and grassroots clean energy innovations.</p>
      <p >RISE will act as a one-stop repository that creates awareness about India’s indigenous innovations on
        renewables
        which leads to collaboration amongst relevant actors to expand commercialisation and uptake. </p>
    </div>
    <button>Upload Innovation Case Study</button>
  </div>
  <div class="objectives-outer-container">
    <div class="objectives-inner-container objectives-inner-container-first">
      <h3>Objectives</h3>
    </div>
    <div class="objectives-inner-container">
      <div class="img-container">
        <img src="assets\images\innovation-showcase\Group 19.png" alt="card center logo">
      </div>
      <p >Accelerate India’s progress towards the ambitious 2030 renewable energy capacity target of 500 GW through
        ‘innovations from India, for India’. </p>
    </div>
    <div class="objectives-inner-container">
      <div class="img-container">
        <img src="assets\images\innovation-showcase\Group 20.png" alt="card center logo">
      </div>
      <p >Publicise promising indigenous RE innovations from across the country to foster awareness and networking
        opportunities.</p>
    </div>
    <div class="objectives-inner-container">
      <div class="img-container">
        <img src="assets\images\innovation-showcase\Group 21.png" alt="card center logo">
      </div>
      <p>Attract potential donors / investors / CSR funders / financiers to enable commercialisation of promising
        technologies. </p>
    </div>
    <div class="objectives-inner-container">
      <div class="img-container">
        <img src="assets\images\innovation-showcase\Group 22.png" alt="card center logo">
      </div>
      <p>Foster collaborations and connections with labs / academia / industry / investors / funders / international
        research
        community to pilot, commercialise, and scale these solutions.</p>
    </div>
  </div>

  <div class="features-outer-container">
    <div class="features-inner-container features-inner-container-first">
      <h3>Features of the RISE Platform</h3>
    </div>
    <div class="features-inner-container">
      <div class="img-container">
        <img src="assets\images\innovation-showcase\Group 177.png" alt="card center logo">
      </div>
      <p>Each innovator would have a dedicated page with details (verified by MNRE) about the innovative
        technology / product / solution / process along with a write-up supported by videos / URLs.</p>
    </div>
    <div class="features-inner-container">
      <div class="img-container">
        <img src="assets\images\innovation-showcase\Group 178.png" alt="card center logo">
      </div>
      <p>The innovator’s page would feature contact details / URLs to the Linkedin page to facilitate collaborations</p>

    </div>
    <div class="features-inner-container">
      <div class="img-container">
        <img src="assets\images\innovation-showcase\Group 179.png" alt="card center logo">
      </div>
      <p>A credible repository of RE technology innovators and research trends across the country could help funders
        spot collaboration opportunities </p>
    </div>
    <div class="features-inner-container features-inner-container-first">
      <p class="font-weight-six"> Submit your application ( <span> insert a hyperlink to the word doc</span> ) </p>
    </div>
  </div>

  <div class="col-xl-10 application-selection-main-news-bar-outer-contaner">
    <h3>Application and Selection Process</h3>
    <div class="card">
      <div class="card-body">
        <!-- Nav tabs -->
        <ul ngbNav #justifiednav="ngbNav" [activeId]="1" class="nav-pills nav-justified">
          <li [ngbNavItem]="1">
            <a ngbNavLink>
              <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
              <span class="d-none d-sm-block">Eligibility</span>
            </a>
            <ng-template ngbNavContent>
              <ng-template [ngTemplateOutlet]="TabContent"></ng-template>
              <p>Academic institutions/labs/not-for-profits/Indian industry (small/medium/large scale private or public
                sector units)/start-ups/NGOs/Research institutions/societies/students/individuals) are encouraged to
                submit their application for the MNRE R&D Innovation Showcase, provided the technologies/products are
                validated by MNRE’s autonomous institutes ( <span> National Institute of Solar Energy, National Institute of
                Wind Energy, Sardar Swaran Singh National Institute of Bioenergy </span> ), or Centres of Excellence ( <span> National
                Centre for Photovoltaic Research and Education, IIT-Bombay, Alternate Hydro Energy Centre </span> ) or any other
                BIS-accredited lab.</p>
            </ng-template>
          </li>
          <li [ngbNavItem]="2">
            <a ngbNavLink>
              <span class="d-block d-sm-none"><i class="far fa-user"></i></span>
              <span class="d-none d-sm-block">Application Form</span>
            </a>
            <ng-template ngbNavContent>
              <ng-template [ngTemplateOutlet]="TabContent1"></ng-template>
              <p>R&D Portal website by filling out a form ( <span> insert a hyperlink to the word doc </span>) and uploading supporting
                documents (PowerPoint/URLs/videos). </p>
            </ng-template>
          </li>
          <li [ngbNavItem]="3">
            <a ngbNavLink>
              <span class="d-block d-sm-none"><i class="far fa-envelope"></i></span>
              <span class="d-none d-sm-block">Final Shortlisting and Publishing on the Showcase platform</span>
            </a>
            <ng-template ngbNavContent>
              <ng-template [ngTemplateOutlet]="TabContent"></ng-template>
              <p>The selection would be carried out by the MNRE R&D team of experts. Officials from the MNRE may contact
                you for clarifications or information. Selected applicants would receive a confirmation email and letter
                from MNRE about being featured on the MNRE R&D Innovation Showcase on Energy (RISE) webpage following
                which applicants need to share a self-declaration of no dues towards any statutory body. Once this
                declaration is received, the applicant/innovator’s profile is made live on the website.</p>
            </ng-template>
          </li>
        </ul>
        <div [ngbNavOutlet]="justifiednav" class="text-muted"></div>
      </div><!-- end card-body -->
    </div><!-- end card -->
  </div>

  <div class="innovators-card-outer-container">

    <div class="innovators-card-inner-container">
      <h3>Selection of RISE Innovators</h3>
      <hr>
      <p>The participants are requested to submit details of their prototype / technology / product / process in the format
        attached as Annexure-I with requisite documents such as URLs / videos. </p>
      <p>The Shortlisted Participants would be required to make a Presentation in front of the MNRE – either virtual or
        physical. The selected innovators would get an opportunity to showcase their products on the MNRE R & D portal.
      </p>
    </div>
    <div class="innovators-card-inner-container">
      <h3>Your Application would be Considered based on the Following Parameters: </h3>
      <hr>
      <p>a) USP / innovation for the proposed pilot </p>
      <p>b) Applications and Ease of Scalability of the proposed solution </p>
      <p>c) Ease of implementation or adoption</p>
      <p>d) Cost-effectiveness </p>
      <p>e) Impact </p>
    </div>

  </div>
</div>